import React, { FC } from 'react';
import Lottie from 'lottie-react';
import styled from 'styled-components';
import notFoundData from '../assets/lottie/not-found.json';

export const FourOhFour: FC = () => {
    return (
        <Container>
            <LottieContainer>
                <Lottie
                    animationData={notFoundData}
                    loop={true}
                    autoplay={true}
                    style={{ height: '100%', width: '100%' }}
                />
            </LottieContainer>
            <Title>Oups... On a bien cherché, mais la page demandée est introuvable</Title>
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

const LottieContainer = styled.div`
    width: 70%;
    height: 70%;
`;

const Title = styled.span`
    text-align: center;
    font-size: 48px;
`;
